import React from 'react';
import { CloseOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Col, Input, InputNumber, Rate, Row } from 'antd';

export default function ClientReviews({ Form }) {
	return (
		<Form.List name='clientReviews'>
			{(fields, { add, remove }) => (
				<>
					{fields.map(({ key, name }) => (
						<Row gutter={[16, 0]} key={key}>
							<Col sm={24} md={6}>
								<Form.Item label='Client Name' name={[name, 'clientname']}>
									<Input placeholder='e.g. John Doe' autoFocus />
								</Form.Item>
							</Col>
							<Col sm={24} md={4}>
								<Form.Item label='Review Date' name={[name, 'Reviewdate']}>
									<Input placeholder='e.g. March 13, 2025' />
								</Form.Item>
							</Col>
							<Col sm={24} md={10}>
								<Form.Item label='Review Message' name={[name, 'reviewmessage']}>
									<Input.TextArea placeholder='Client feedback here...' rows={4} />
								</Form.Item>
							</Col>

							<Col sm={24} md={1}>
								{fields.length > 1 ? (
									<Form.Item label='&nbsp;'>
										<Button icon={<CloseOutlined />} shape='circle' onClick={() => remove(name)} />
									</Form.Item>
								) : null}
							</Col>
						</Row>
					))}
					<Row gutter={[16, 0]}>
						<Col sm={24} md={6}>
							<Form.Item>
								<Button icon={<PlusOutlined />} type='primary' onClick={() => add()} style={{ width: '100%' }}>
									Add Client Review
								</Button>
							</Form.Item>
						</Col>
					</Row>
				</>
			)}
		</Form.List>
	);
}
